
import Vue from 'vue'
import BusinessHours from '../../common/business-hours/index.vue'

export enum Weekdays {
  monday = 'Понедельник',
  tuesday = 'Вторник',
  wednesday = 'Среда',
  thursday = 'Четверг',
  friday = 'Пятница',
  saturday = 'Суббота',
  sunday = 'Воскресенье'
}

export default Vue.extend({
  name: 'OfficeTableRow',
  components: {
    BusinessHours
  },
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    link: {
      type: String,
      required: false,
      default: ''
    },
    address: {
      type: String,
      required: true,
      default: ''
    },
    hours: {
      type: String,
      required: true,
      default: ''
    },
    disabilitySupport: {
      type: Boolean,
      required: true,
      default: false
    },
    useMerge: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      Weekdays
    }
  }
})
